import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { Colors } from '@src/colors';
import styled from 'styled-components';
import { Button } from './Button';

export const AddressInput = styled.div`
    display: flex;
    gap: 6px;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        width: 100%;
    }

    *,
    *:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
`;

export const Search = styled.div<{ hasResult: boolean }>`
    padding: 0;
    width: 100%;

    > svg {
        > path {
            fill: ${Colors.midnight};
        }
        height: 24px;
        margin-left: 11px;
        margin-top: 16px;
        position: absolute;
    }

    > input {
        border-radius: 4px 0 0 ${(props) => (props.hasResult ? 0 : '4px')};
        box-sizing: border-box;
        padding: 0 41px 0 41px;
        height: 56px;
        width: 100%;

        color: ${Colors.duskLighter};
        font-family: 'Public Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: left;
    }
`;

export const SubmitButton = styled(Button)`
    border-radius: 0 4px 4px 0;
    height: 56px;
    margin: auto;
    width: 56px;
    padding: 0;
`;

export const Suggestions = styled.div`
    position: relative;

    > ul {
        background: ${Colors.white};
        border: 1px solid ${Colors.white};
        border-radius: 0 0 4px 4px;
        box-shadow: 0 8px 16px 0 rgb(0 0 0 / 20%);
        box-sizing: border-box;
        list-style: none;
        padding: 0;
        position: absolute;
        width: 100%;
        z-index: 1;
    }
`;

export const Suggestion = styled.div<{ selected: boolean }>`
    > a {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-family: 'Public Sans';

        gap: 10px;
        border-top: 1px solid #e6e6e6;
        padding: 5px 11px;
        font-size: small;
        background: ${(props) => (props.selected ? Colors.ownerYellow : Colors.white)};

        color: ${Colors.duskLighter};
        & > svg {
            path {
                fill: ${Colors.duskLighter};
            }
        }

        :hover,
        :focus,
        :active {
            outline: unset;
            box-shadow: unset;
            color: ${Colors.duskLightest};
            > svg > path {
                fill: ${Colors.duskLightest};
            }
        }
    }
`;
